import defaultApp from './defaultApp.js';
import { userStore } from './store/userStore.js';
import vodItem from './components/VODitem.vue';
import vodSkeleton from './components/VODskeleton.vue';
import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
const axios = require('axios');


const catalogApp = {
    components: { vodItem, vodSkeleton },
    ...defaultApp,
    data() {
        return {
            ...defaultApp.data(),
            favouritesApi: '',
            bannerApi: '',
            dataAmountsSentence: '',
            dataLimit: 12,
            dataFeaturedIds: [],
            bannersVisible: 0,
            banners: [],
            page: 1,
            searchText: ''
        }
    },
    computed: {
        ...defaultApp.computed,
        filterItems() {
            if (!this.filtersChosen) return [];
            if (this.dataOverruleIds.length) {
                return [{
                    Key: 'cmsNodeId',
                    Values: this.dataOverruleIds,
                    Operator: 'In'
                }]
            }
            return this.data.facets.filter(f => f.values.length).map(facet => {
                return {
                    Key: facet.alias,
                    Values: facet.values,
                    Operator: 'In'
                }
            });
        },
        amountsSentence() {
            if (!this.data || !this.data.queryCount || !this.data.totalCount) return null;
            return this.dataAmountsSentence.replace('{{totalCount}}', this.data.queryCount);
        },
        user() {
            return userStore.user;
        },
        loggedIn() {
            return userStore.loggedIn;
        }
    },
    methods: {
        ...defaultApp.methods,
        async init() {
            this.loading = true;
            if (this.$el.dataset.widget) this.dataWidget = this.$el.dataset.widget === 'true';
            if (this.$el.dataset.overruleids) this.dataOverruleIds = this.$el.dataset.overruleids.split(',');
            if (this.$el.dataset.featureids) this.dataFeaturedIds = this.$el.dataset.featureids.split(',');
            if (this.$el.dataset.favouritesapi) this.favouritesApi = this.$el.dataset.favouritesapi;
            if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
            if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
            if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
            if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;
            if (this.$el.dataset.showxamountoftotalitems) this.dataAmountsSentence = this.$el.dataset.showxamountoftotalitems;
            if (this.$el.dataset.bannerapi) this.bannerApi = this.$el.dataset.bannerapi;

            if (this.bannerApi.length) {
                const response = await this.fetchBanners();
                this.banners = response.data.items;
            }

            const urlParams = new URLSearchParams(window.location.search);

            let pageParam = urlParams.has('page') ? parseInt(urlParams.get('page')) : 0;
            if (pageParam) urlParams.delete('page');
            if (pageParam < 2) pageParam = 0;
            this.searchText = urlParams.has('text') ? urlParams.get('text') : '';
            if (this.searchText) urlParams.delete('text');
            let filterParams = urlParams.toString() ? urlParams : null;

            let tempLimit = this.dataLimit;
            if (pageParam && !this.dataWidget) {
                this.page = pageParam;
                this.dataLimit = this.dataLimit * this.page;
            }

            if (filterParams && !this.dataWidget) {
                let filterQuery = [];
                filterParams.forEach((value, key) => {
                    filterQuery.push({ Key: key, Values: value.split(','), Operator: 'In' });
                });
                this.queryModel.FilterItems = filterQuery;
            }

            if (this.dataOverruleIds.length) {
                const overruleResponse = await this.fetchData();
                if (overruleResponse && overruleResponse.data && overruleResponse.data.items && overruleResponse.data.items.length) {
                    overruleResponse.data.items = overruleResponse.data.items.sort((a, b) => this.dataOverruleIds.indexOf(a.cmsNodeId) - this.dataOverruleIds.indexOf(b.cmsNodeId));
                }
                this.setData(overruleResponse);
                this.dataOverruleIds = [];
                if (this.data.items.length < this.dataLimit) {
                    this.loadMore = true;
                    if (this.dataFeaturedIds.length) {
                        this.queryModel.FilterItems = [{
                            Key: 'features.id',
                            Operator: 'In',
                            Values: this.dataFeaturedIds
                        }];
                    }
                    const featureResponse = await this.fetchData();
                    if (this.dataFeaturedIds.length > 1) {
                        featureResponse.data.items = this.sortObjectsByFeatureIds(featureResponse.data.items)
                    }
                    this.setData(featureResponse);

                    if (this.itemsSet) {
                        this.data.items = this.data.items.slice(0, this.dataLimit);
                        this.data.items = this.removeDuplicatesById(this.data.items);
                        if (this.data.items.length < this.dataLimit) {
                            this.dataLimit = this.dataLimit - this.data.items.length;
                            this.queryModel.FilterItems = [{
                                Key: 'cmsNodeId',
                                Values: this.data.items.map(item => item.cmsNodeId),
                                Operator: 'NotIn'
                            }];
                            const restResponse = await this.fetchData();
                            this.setData(restResponse);
                        }
                    }

                    this.loadMore = false;
                    this.dataLimit = tempLimit;
                }
            } else {
                if (this.dataFeaturedIds.length) {
                    this.queryModel.FilterItems = [{
                        Key: 'features.id',
                        Operator: 'In',
                        Values: this.dataFeaturedIds
                    }];

                    const featureResponse = await this.fetchData();
                    if (this.dataFeaturedIds.length > 1) {
                        featureResponse.data.items = this.sortObjectsByFeatureIds(featureResponse.data.items);
                    }
                    this.setData(featureResponse);
                    if (this.itemsSet) {
                        if (this.dataWidget) {
                            if (this.data.items.length < this.dataLimit) {
                                this.dataLimit = this.dataLimit - this.data.items.length;
                                this.loadMore = true;
                                this.queryModel.FilterItems = [{
                                    Key: 'cmsNodeId',
                                    Values: this.data.items.map(item => item.cmsNodeId),
                                    Operator: 'NotIn'
                                }];
                                const restResponse = await this.fetchData();
                                this.setData(restResponse);
                                this.loadMore = false;
                            }
                        }
                    }
                } else {
                    const response = await this.fetchData();
                    this.setData(response);
                }

                this.dataLimit = tempLimit;
            }

            this.loading = false;

            this.$nextTick(() => {
                if (this.dataWidget) {
                    let $swiper = this.$el.querySelector('.swiper');
                    let $next = this.$el.querySelector('.fa-arrow-right-long');
                    let $prev = this.$el.querySelector('.fa-arrow-left-long');
                    let $pagination = this.$el.querySelector('.swiper-pagination');
                    new Swiper($swiper, {
                        modules: [Pagination, Navigation],
                        slidesPerView: 1.2,
                        spaceBetween: 24,
                        watchSlidesProgress: true,
                        slidesPerGroup: 1,
                        breakpoints: {
                            480: {
                                slidesPerView: 2.2
                            },
                            769: {
                                slidesPerView: 3.2,
                                slidesPerGroup: 2
                            },
                            1024: {
                                slidesPerView: 3.4,
                                slidesPerGroup: 3
                            },
                            1216: {
                                slidesPerView: 4.8,
                                slidesPerGroup: 4
                            }
                        },
                        navigation: {
                            addIcons: false,
                            nextEl: $next,
                            prevEl: $prev
                        },
                        pagination: {
                            el: $pagination,
                            type: 'fraction',
                        },
                        renderFraction: function (currentClass, totalClass) {
                            return '<span class="' + currentClass + '"></span>' +
                                ' / ' +
                                '<span class="' + totalClass + '"></span>';
                        }
                    });
                }
            });
        },
        async fetchData() {
            try {
                const response = await axios.post(this.dataApi, this.queryModel);
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        async fetchBanners() {
            try {
                const response = await axios.get(this.bannerApi);
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        async fetchPurchases() {
            try {
                const response = await axios.get(this.purchasesApi);
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        setData(response) {
            if (!response || response.status != 200) return;
            if (!this.loadMore) {
                this.data = response.data;
                this.data.items = response.data.items.map(item => {
                    return {
                        ...item,
                        type: 'voditem',
                        isPayed: this.loggedIn && this.user.purchasedVodItems.some(p => p.id === item.id),
                        favourite: this.loggedIn && this.user.favouriteVodItems.includes(item.id)
                    }
                });
                this.data.facets = response.data.facets.sort((a, b) => a.sortOrder - b.sortOrder).map(facet => {
                    return {
                        ...facet,
                        values: facet.options.filter(option => option.selected).map(option => option.valueAlias),
                    }
                });
                this.data.items = this.mergeArrays(this.data.items, this.banners);
            } else {
                if (response.data.items && response.data.items.length) {
                    response.data.items = response.data.items.map(item => {
                        return {
                            ...item,
                            isPayed: this.loggedIn && this.user.purchasedVodItems.some(p => p.id === item.id),
                            favourite: this.loggedIn && this.user.favouriteVodItems.includes(item.id),
                            type: 'voditem'
                        }
                    });
                    let newItems = [];
                    if (this.banners.length && this.banners.slice(this.bannersVisible).length) {
                        newItems = this.mergeArrays(response.data.items, this.banners.slice(this.bannersVisible));
                    } else {
                        newItems = response.data.items;
                    }
                    this.data.items = this.data.items.concat(newItems);
                }
            }
        },
        reset() {
            this.data.facets.forEach(facet => facet.values = []);
            this.searchText = '';
            this.fetchInitialData();
        },
        updateUrl() {
            if (!this.queryModel.Text && !this.queryModel.FilterItems.length && this.page === 1) {
                history.pushState({}, null, window.location.pathname);
                return;
            }
            const urlParams = new URLSearchParams();
            if (this.queryModel.Text) urlParams.append('text', this.queryModel.Text);
            if (this.queryModel.FilterItems.length) {
                this.queryModel.FilterItems.forEach(filterItem => urlParams.append(filterItem.Key, filterItem.Values.join()))
            }
            if (this.page > 1) urlParams.append('page', this.page);
            history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
        },
        mergeArrays(items, banners) {
            if (!banners.length) return items;
            let position = 4;
            this.bannersVisible = 0;
            return items.reduce((acc, curr, index) => {
                acc.push(curr);
                if ((index + 1) % position === 0) {
                    const injectIndex = (index + 1) / position - 1;
                    if (injectIndex < banners.length) {
                        this.bannersVisible++;
                        acc.push(banners[injectIndex]);
                    }
                }
                return acc;
            }, []);
        },
        submitSearch() {
            const $form = this.$el.querySelector('form');
            const params = new URLSearchParams(new FormData($form));
            for (let key of [...params.keys()]) {
                if (params.get(key).trim() === '') {
                    params.delete(key);
                }
            }
            const action = $form.action.split('?')[0];
            const newUrl = params.toString().length ? action + '?' + params.toString() : action;
            window.location.href = newUrl;
        },
        bannerBackgroundClass(color) {
            let backgroundColor = 'has-background-primary';
            let bannerColor = color !== '' ? JSON.parse(color)[0] : '';
            switch (bannerColor) {
                case 'blauw':
                    backgroundColor = 'has-background-link';
                    break;
                case 'groen':
                    backgroundColor = 'has-background-success';
                    break;
                case 'beige':
                    backgroundColor = 'has-background-info';
                    break;
                default:
                    backgroundColor = 'has-background-primary';
                    break;
            }
            return backgroundColor;
        },
        async handleVodFavourite(id) {
            let url = this.favouritesApi + id;
            let item = this.data.items.find(item => item.id === id);
            if (this.user.favouriteVodItems.includes(id)) {
                const response = await this.fetchApiData(url, '', 'delete');
                if (response.status === 200 && response.data) {
                    this.user.favouriteVodItems = this.user.favouriteVodItems.filter(fav => {
                        return fav !== id;
                    });
                    item.favourite = false;
                }
            } else {
                const response = await this.fetchApiData(url, '', 'put');
                if (response.status === 200 && response.data.typeAlias === 'Success') {
                    this.user.favouriteVodItems.push(id);
                    item.favourite = true;
                }
            }
            userStore.updateUser(this.user);
        },
        sortObjectsByFeatureIds(objs) {
            const sorted = [];
            const objGroups = {};
            const added = new Set();

            objs.forEach(item => {
                item.features.forEach(feature => {
                    if (!objGroups[feature.id]) objGroups[feature.id] = [];
                    objGroups[feature.id].push(item);
                });
            });

            const indices = this.dataFeaturedIds.map(() => 0);
            let totalAdded = 0;
            const totalToAdd = objs.length;
            let madeProgress;

            while (totalAdded < totalToAdd) {
                madeProgress = false;

                for (let i = 0; i < this.dataFeaturedIds.length; i++) {
                    const fid = this.dataFeaturedIds[i];
                    const group = objGroups[fid];
                    if (group && indices[i] < group.length) {
                        while (indices[i] < group.length) {
                            const obj = group[indices[i]];
                            indices[i]++;
                            const key = obj.id ?? objs.indexOf(obj);

                            if (!added.has(key)) {
                                sorted.push(obj);
                                added.add(key);
                                totalAdded++;
                                madeProgress = true;
                                break;
                            }
                        }
                    }
                }

                if (!madeProgress) {
                    break;
                }
            }

            return sorted;
        
        }
    },
    created() {
        this.changeSearchText = this.debounce(event => {
            this.fetchInitialData();
        });
    },
    mounted() {
        let self = this;
        window.addEventListener('memberChanged', (event) => {
            userStore.user = event.detail.user;
            let response = {
                status: 200,
                data: self.data
            }
            self.setData(response);
        });
        this.init();
    }
};

export default catalogApp;
